export default __webpack_public_path__ + "static/Entenda0125-435aeced6d92a54daa4dfa9c7316c69d.jpg";